import { useEffect, useState } from 'react';
import { getCodingJob } from '../api';

export const GRADING_TERMINAL = new Set(['completed', 'needs_reconciliation', 'dead_letter']);

export function gradingMessage(state) {
  if (state === 'completed') return 'Grading complete. Your results have been saved.';
  if (state === 'needs_reconciliation' || state === 'dead_letter') {
    return 'Your submission is saved. Grading needs attention; you do not need to submit again.';
  }
  return 'Your submission is saved. Grading is in progress; you can safely leave this page.';
}

export default function useGradingJob(jobId) {
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    if (!jobId) return undefined;
    let cancelled = false;
    let timer;
    let polls = 0;
    const controller = new AbortController();
    const poll = async () => {
      if (cancelled || polls >= 120) return;
      if (document.visibilityState === 'hidden') {
        timer = setTimeout(poll, 10000);
        return;
      }
      polls += 1;
      try {
        const next = await getCodingJob(jobId, controller.signal);
        if (cancelled) return;
        setData(next);
        if (GRADING_TERMINAL.has(next.grading_status)) return;
      } catch (error) {
        if (cancelled) return;
        // A status check failure must never trigger another submission.
      }
      timer = setTimeout(poll, Math.min(30000, 2500 * Math.pow(1.3, polls)));
    };
    poll();
    return () => { cancelled = true; clearTimeout(timer); controller.abort(); };
  }, [jobId]);
  return data;
}
